import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { login } from '../store/slices/authSlice';

const LoginPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { loading, error } = useAppSelector((s) => s.auth);
  const [form, setForm] = useState({ username: '', password: '' });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const result = await dispatch(login(form));
    if (login.fulfilled.match(result)) navigate('/workspace');
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 style={{ textAlign: 'center', color: 'var(--crm-text)', marginBottom: '24px' }}>CRM4Chef — Вхід</h2>
        {error && (
          <div
            style={{
              background: 'var(--crm-danger-bg)',
              color: 'var(--crm-danger)',
              border: '1px solid var(--crm-danger)',
              padding: '10px',
              borderRadius: '4px',
              marginBottom: '16px',
            }}
          >
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', color: 'var(--crm-text)' }}>Логін</label>
            <input
              type="text"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid var(--crm-border)',
                borderRadius: 'var(--crm-radius-sm)',
                background: 'var(--crm-input-bg)',
                color: 'var(--crm-text)',
                boxSizing: 'border-box',
              }}
              required
            />
          </div>
          <div style={{ marginBottom: '24px' }}>
            <label style={{ display: 'block', marginBottom: '4px', color: 'var(--crm-text)' }}>Пароль</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid var(--crm-border)',
                borderRadius: 'var(--crm-radius-sm)',
                background: 'var(--crm-input-bg)',
                color: 'var(--crm-text)',
                boxSizing: 'border-box',
              }}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              background: 'var(--crm-danger-bg)',
              color: 'var(--crm-danger)',
              border: '1px solid var(--crm-danger)',
              borderRadius: 'var(--crm-radius-sm)',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            {loading ? 'Вхід...' : 'Увійти'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: '16px', color: 'var(--crm-text-muted)' }}>
          Немає акаунту?{' '}
          <Link to="/register" style={{ color: 'var(--crm-accent)' }}>
            Реєстрація
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
